import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

import Wrapper from '../../elements/wrapper';
import { media } from '../../helpers';

const BrandedStylesContainer = styled.div`
    padding-bottom: 10vh;
    .title-container {
        text-align: center;
        margin-bottom: 50px;
        h3 {
            font-size: 2.4rem;
            color: #000;
            font-weight: 800;
            margin: 0;
            font-family: neue-kabel, sans-serif;
        }
    }

    .styles-wrapper {
        ${media.medium`display: flex; max-width: 65vw;`}

        .item-container {
            margin-bottom: 20px;

            &:last-child {
                margin-bottom: 0px;
            }
            > .inner-wrap {
                display: flex;
                box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
                margin: 0 auto;
                ${media.medium`max-width: 90%;`}
                .image-container {
                    flex: 1;
                    .gatsby-image-wrapper {
                        max-width: 250px;
                    }
                }
                .content-container {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    .inner-wrap {
                        flex: 1;
                        padding: 0 20px;

                        h3 {
                            color: #000;
                            font-family: neue-kabel, sans-serif;
                            font-weight: 800;
                            margin: 0 0 15px;
                        }

                        p {
                            font-size: 0.9rem;
                            color: #000;
                        }
                    }
                }
            }
        }
    }
`;

const BrandedStyles = ({ content }) => {
    const { sectionTitle, styleItems } = content || {};
    return (
        <BrandedStylesContainer>
            <Wrapper className="title-container">
                <h3>{sectionTitle}</h3>
            </Wrapper>
            <Wrapper className="styles-wrapper">
                {styleItems &&
                    styleItems.map((item, index) => {
                        const { styleImage, styleBlurb, styleTitle } =
                            item || {};
                        return (
                            <div className="item-container" key={index}>
                                <div className="inner-wrap">
                                    <div className="image-container">
                                        <Img
                                            fluid={
                                                styleImage.localFile
                                                    .childImageSharp.fluid
                                            }
                                            alt={styleTitle + ' image'}
                                        />
                                    </div>
                                    <div className="content-container">
                                        <div className="inner-wrap">
                                            <h3>{styleTitle}</h3>
                                            <p>{styleBlurb}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
        </BrandedStylesContainer>
    );
};

export default BrandedStyles;
